export default {"src":"/_next/static/media/snow_shoeing.f4ef015a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};